import React from 'react';
import { NotebookTabs as LucideNotebookTabs } from 'lucide-react';

interface NotebookTabsProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const NotebookTabs: React.FC<NotebookTabsProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideNotebookTabs width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default NotebookTabs;
